<a
  [routerLink]="[$homepageUrl | async, 'videos', video.docId]"
  [ngSwitch]="direction"
>
  <span
    *ngIf="linkLabel"
    class="text-semibold text-md m-b-12 none lg:block text-center text-primary"
  >
    {{ linkLabel }}
  </span>

  <div
    class="card-group flex flex-row-reverse flex-justify-between gap-16 lg:block rounded-md"
  >
    <yo-video-card
      *ngIf="channel"
      class="none lg:block"
      [imageUrl]="video.posterImage"
      size="sm"
      [startDate]="video.streamState === 'SCHEDULED' ? video.startTime : null"
      [duration]="video.duration || 0"
      [scheduledTime]="
        video.startTime && video.endTime
          ? { startTime: video.startTime, endTime: video.endTime }
          : undefined
      "
      [isLive]="video.streamState === 'LIVE'"
      [liveLabel]="liveLabel"
      [isUpcoming]="video.streamState === 'SCHEDULED'"
      [isLocked]="!!(isVideoLocked$ | async)"
      [lockText]="videoLockText"
    >
    </yo-video-card>

    <yo-video-card
      class="block lg:none"
      [imageUrl]="video.posterImage"
      size="sm"
    >
    </yo-video-card>
    <p
      class="flex flex-column flex-justify-between flex-align-start lg:block gap-8"
    >
      <span
        *ngIf="linkLabel"
        class="text-secondary text-sm block lg:none m-8 m-b-0"
      >
        {{ linkLabel }}
      </span>
      <span
        class="block text-primary text-sm text-semibold m-l-8 lg:m-t-12 lg:m-b-8 lg:m-r-8 text-wrap"
        >{{ video.name | truncate : 50 }}</span
      >
    </p>
  </div>
</a>
